import dynamic from 'next/dynamic';

import { StarRating } from '@virginexperiencedays/components-v2/src/StarRating';
import { roundAverageRating } from '@virginexperiencedays/components-v2/src/utils/productRating';

import { allOneStar } from './Reviews/reviewsUtil';

const ReviewsComponent = dynamic(() => import('./Reviews/index'), {
  ssr: false,
});

export const Reviews = ({ isPreviousVisible, reviews, averageRating, totalReviews }) => {
  if (!reviews?.length || allOneStar(reviews)) return null;
  const basedOnReviewsText =
    totalReviews > 1 ? `Based on ${totalReviews} reviews` : `Based on ${totalReviews} review`;

  return isPreviousVisible ? (
    <ReviewsComponent
      className="mx-0 my-10 pt-10 md:my-20"
      id="customer-reviews"
      title="Customer Reviews"
      averageRating={averageRating}
      totalReviews={totalReviews}
      reviews={reviews}
    />
  ) : (
    // Placeholder to keep DOM structure until intersection observer is trigerred
    <div id="customer-reviews" className="hidden">
      <h2>Customer Reviews</h2>
      {reviews.map((review, index) => {
        const date = new Date(review.dateCreated).toLocaleDateString('en-GB');
        return (
          <div key={index}>
            <div>
              <div>{roundAverageRating(averageRating, true)}</div>
              <p> out of 5 stars</p>
            </div>
            <StarRating rating={averageRating} />
            <p>{basedOnReviewsText}</p>
            <p>Find out what others have to say about this experience</p>
            <div>
              <p>{review.rating}</p>
              <p>{review.reviewerName}</p>
              <p>{date}</p>
            </div>
            <h3>{review.title}</h3>
            <p>{review.content}</p>
          </div>
        );
      })}
    </div>
  );
};
